module.exports = __webpack_public_path__ + "media/app/assets/races/lightforged_draenei_male-8b1708b3e23a0b08f01c597c7621f4b1.png";